import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Assign Resourcing Owner\n          ")
], -1);
const _hoisted_4 = { class: "overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", null, "Select the admin you would like to assign this offer to: *", -1);
const _hoisted_7 = {
    key: 1,
    class: "border border-gray-300 rounded-lg p-6"
};
const _hoisted_8 = { class: "flex justify-end" };
const _hoisted_9 = { class: "mt-6" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiringManagerName",
    class: "block text-sm font-medium text-gray-700"
}, "Admin name: *", -1);
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "col-span-6 mt-4" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiringManagerEmail",
    class: "block text-sm font-medium text-gray-700"
}, "Admin email address: *", -1);
const _hoisted_14 = ["value"];
const _hoisted_15 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_16 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_UserSearch = _resolveComponent("UserSearch");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        (!_ctx.formData?.recruitment_owner)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _createVNode(_component_UserSearch, {
                                    group: "RESOURCING",
                                    onUpdatedUser: _ctx.handleUser
                                }, null, 8, ["onUpdatedUser"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_XIcon, {
                                        class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer",
                                        onClick: _ctx.handleClearUser
                                    }, null, 8, ["onClick"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        value: _ctx.username,
                                        type: "text",
                                        name: "hiringManagerName",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        disabled: ""
                                    }, null, 8, _hoisted_11)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        value: _ctx.userEmail,
                                        type: "email",
                                        name: "hiringManagerEmail",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        disabled: ""
                                    }, null, 8, _hoisted_14)
                                ])
                            ]))
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.disableForm && _ctx.data.currentStageName === 'starter.notifyRecruitment')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.confirmAssignAdmin && _ctx.confirmAssignAdmin(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_16)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
